export enum Patterns {
  SingleDigit = '^[0-9]$',
  Digits = '^[0-9]+$',
  Letter = '^[a-zA-Z]+$',
  AlphaNumeric = '^[a-zA-Z0-9]+$',
  Email = '^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}$',
  // eslint-disable-next-line max-len
  Password = '((?=.*[a-z])(?=.*[A-Z])(?=.*\\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])|(?=.*[a-z])(?=.*\\d)(?=.*[^A-Za-z0-9])|(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9]))([A-Za-z\\d@#$%^&*\\-_+=[\\]{}|\\:\',?/`~"();!]|\\.(?!@)){8,16}$',
}

export enum PatternTypes {
  SingleDigit = 0,
  Digits,
  Letter,
  AlphaNumeric,
  Email,
}
